"use client"

import React from "react"
import mainContext from "../../contexts/mainContext"
import { getBabySittersListing } from "../../Controllers/userManagment/babySitter"
import { deleteUser } from "../../Controllers/userManagment/common"

import SearhcBar from "./SearhcBar"
import UserCard from "./UserCard"
import Pagination from "@mui/material/Pagination"
import LoopIcon from "@mui/icons-material/Loop"
import { __constants, __snackBarText, __snackBarSeverity } from "../../constants"

const BabySittersListing = () => {
  const { setSnackBar, setProfileNavTitle, nth, months, loginUserDetails, setPageload, pageload } =
    React.useContext(mainContext)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [babySitters, setBabySitters] = React.useState([])
  const [totalCount, setTotalCount] = React.useState(1)
  const [filterState, setFilterState] = React.useState({})

  const callSnackBar = (msg, type) => {
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    })
  }
  const getBabySitters = async (page, filterApply = true) => {
    let param = null
    if (filterApply) {
      param = { page: page, ...filterState }
      if (loginUserDetails.role === "Concierge") param.conceirgeId = loginUserDetails._id
    } else {
      param = { page: page }
      if (loginUserDetails.role === "Concierge") param.conceirgeId = loginUserDetails._id
    }
    setPageload(true)
    setBabySitters([])
    const res = await getBabySittersListing(param)
    setPageload(false)
    if (res && res.status === 500) {
      return callSnackBar(__snackBarText.internalServerError, "error")
    }
    if (res.data.status !== 200) {
      return callSnackBar(res.data.errors[0].message, "error")
    }
    setBabySitters(res.data.data.babySitter)
    setTotalCount(res.data.data.total)
  }

  const handlePaginationClick = (e, page) => {
    setCurrentPage(page)
    getBabySitters(page)
  }

  React.useEffect(() => {
    getBabySitters(1)
    setProfileNavTitle("BABYSITTERS")
    // eslint-disable-next-line
  }, [])

  /* Handle update profile */
  const handleUpdate = (data, index) => {
    const temp = [...babySitters]
    temp[index] = data
    setBabySitters(temp)
  }

  /* Handle delete user */
  const handleDelete = async (userId) => {
    setPageload(true)
    const res = await deleteUser(userId)
    setPageload(false)

    if (res && res.status === 500) {
      return callSnackBar(__snackBarText.internalServerError, "error")
    }
    if (res.data.status !== 200) {
      return callSnackBar(res.data.errors[0].message, "error")
    }

    callSnackBar("User deleted successfully", "success")
    // Remove the deleted user from the list
    setBabySitters((prev) => prev.filter((bs) => bs._id !== userId))
    // Update total count
    setTotalCount((prev) => prev - 1)
  }

  return (
    <>
      <SearhcBar
        filterState={filterState}
        setFilterState={setFilterState}
        callFunction={getBabySitters}
        userType="babysitter"
      />
      <div className="component_body scrollbar">
        <div className="list_header Users_list_grid">
          <div>
            <div>Status</div>
          </div>
          <div>Username</div>
          <div>Email</div>
          <div>Phone</div>
          <div>City</div>
          <div>Onboarded</div>
          <div style={{ textAlign: "right" }}>Registered</div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <LoopIcon
              onClick={() => {
                getBabySitters(currentPage)
              }}
              className="pointer"
            />
          </div>
        </div>

        <div>
          {babySitters.map((e, index) => {
            const createdAt = new Date(e.createdAt)
            return (
              <UserCard
                key={e._id}
                userId={e._id}
                openCanvasOf="baby-sitter"
                status={e.status}
                city={e.city || "---"}
                name={e.firstName || e.lastName ? `${e.firstName || ""} ${e.lastName || ""}`.trim() : "---"}
                email={e.email || "---"}
                mobile={e.mobileNo ? `${e.dialCode ? `${e.dialCode} ` : ""}${e.mobileNo}` : "---"}
                userInfo={e}
                type="provider"
                paypal={e?.paypalAccountOnBoard?.completedOn ? true : false}
                stripe={e?.stripeAccountOnBoard?.completedOn ? true : false}
                onUpdate={(data) => handleUpdate(data, index)}
                onDelete={handleDelete}
                added={`${createdAt.getDate()}${nth(createdAt.getDate())} ${months[createdAt.getMonth()].slice(0, 3)} ${createdAt.getFullYear()}`}
              />
            )
          })}
        </div>
        {babySitters.length === 0 && !pageload && (
          <div className="no-record">
            <span>No Record Found</span>
          </div>
        )}
      </div>
      {/* {
        babySitters.length > 0 ? */}
      <>
        <Pagination
          count={Math.ceil(totalCount / __constants.listingLimit)}
          color="primary"
          shape="rounded"
          onChange={(e, page) => {
            handlePaginationClick(e, page)
          }}
        />
        <br />
      </>
      {/* : <></>
      } */}
    </>
  )
}

export default BabySittersListing